export default __webpack_public_path__ + "./images/eg.24e62dc0.png";